import { ProductImageUploadTranslations } from "./product-image-upload-pt-br";

export const PRODUCT_IMAGE_UPLOAD_EN_US: ProductImageUploadTranslations = {
	addImage: "Add image",
	removeImage: "Remove uploaded image",
	formatInfo: "JPG or PNG",
	ariaLabel: {
		uploadedImage: "Uploaded product image",
	},
};
